import logfmt from 'logfmt';

const createLogger = () => {
  let logger = new logfmt();

  // replace our stringify with JSON's
  logger.stringify = JSON.stringify;

  return logger;
};

export function log_info(func: string, param: any, res: any) {
  const logger = createLogger();

  logger
    .namespace({ type: 'info' })
    .log({ function: func, types: param, data: res && JSON.stringify(res) });
}

export function log_error(func: string, type: string, err: any) {
  const logger = createLogger();

  logger
    .namespace({ type: 'error' })
    .log({ function: func, type: type, error: err && JSON.stringify(err) });
}

export default createLogger;
